import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';

import Navbar from './globals/Navigation.jsx';
import Footer from './globals/Footers.jsx';
import Index from './pages/Home.jsx'
import AboutUs from './pages/aboutUs.jsx'
import Projects from './pages/projects.jsx'
import Service from './pages/service.jsx'
import ContactUs from './pages/contactUs.jsx'


function App() {
  return (
    <div className='app-main'>
      <Navbar />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/Service" element={<Service />} />
        <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;


